import React from 'react';
import { useContext } from 'react';

// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------

// Helpers ----------------------------------------------------------------------
import { StoreConfigContext } from '@helpers/storeConfigContext';
import { keyValidate } from '@helpers/validation';
//------------------------------------------------------------------------------

function DefaultStoreContent(props) {
  const { t } = props;
  const li_content = [
    {
      content: t('support_Faq3Textli6'),
    },
    {
      content: t('support_Faq3Textli7'),
    },
  ];
  const available_lis = li_content.filter(
    (liElement) => liElement.content != ''
  );

  return (
    <>
      <div className={styles.SupportContent}>
        {t('support_Faq3Text')}
        <br />
        <br />
        <span className={styles.SpanBold}>{t('support_Faq3TextTitle1')}</span>
        <br />
        <br />
        <div className={styles.UlDiv}>
          <ul>
            <li>{t('support_Faq3Textli1')}</li>
            {t('support_Faq3Textli2') && <li>{t('support_Faq3Textli2')}</li>}
            <li>{t('support_Faq3Textli3')}</li>
            <li>{t('support_Faq3Textli4')}</li>
            {t('support_Faq3Textli5') != '' ? (
              <>
                <li>{t('support_Faq3Textli5')}</li>{' '}
              </>
            ) : (
              <></>
            )}
          </ul>
          <br />
        </div>
        <span className={styles.SpanBold}>{t('support_Faq3TextTitle2')}</span>
        {t('support_Faq3TextImpNoteContent')}
        <br />
        <br />
        <span className={styles.SpanBold}>{t('support_Faq3TextTitle3')}</span>
        <br />
        <br />
        <div className={styles.UlDiv}>
          <ul>
            {available_lis.map((li, key) => (
              <li key={key}> {li.content}</li>
            ))}
          </ul>
          <br />
        </div>
        {t('support_Faq3TextNote')}
      </div>
    </>
  );
}

function JapaneseStoreContent(props) {
  const { t } = props;

  const li_content = {
    heading1li: [
      { content: 'support_Faq3heading1li1' },
      { content: 'support_Faq3heading1li2' },
      { content: 'support_Faq3heading1li3' },
    ],
    heading2li: [
      { content: 'support_Faq3heading2li1' },
      { content: 'support_Faq3heading2li2' },
    ],
    heading3li: [{ content: 'support_Faq3heading3li1' }],
  };

  return (
    <>
      <div className={styles.SupportContent}>
        {keyValidate('support_Faq3heading1') ? (
          <span className={styles.SupportSectionTitle}>
            {t('support_Faq3heading1')}
          </span>
        ) : (
          ''
        )}
        <br />
        <ul>
          {li_content.heading1li.map((li, key) => {
            return keyValidate(li.content) ? (
              <li key={key}> {t(li.content)}</li>
            ) : (
              ''
            );
          })}
        </ul>
        <br />
        <br />
        {keyValidate('support_Faq3heading2') ? (
          <span className={styles.SupportSectionTitle}>
            {t('support_Faq3heading2')}
          </span>
        ) : (
          ''
        )}
        <br />
        {keyValidate('support_Faq3heading2li1') ? (
          <ul>
            {li_content.heading2li.map((li, key) => {
              return keyValidate(li.content) ? (
                <li key={key}> {t(li.content)}</li>
              ) : (
                ''
              );
            })}
          </ul>
        ) : (
          ''
        )}
        <br />
        <br />
        {keyValidate('support_Faq3heading3') ? (
          <span className={styles.SupportSectionTitle}>
            {t('support_Faq3heading3')}
          </span>
        ) : (
          ''
        )}
        <br />
        {keyValidate('support_Faq3heading3li1') ? (
          <ul>
            {li_content.heading3li.map((li, key) => {
              return keyValidate(li.content) ? (
                <li key={key}> {t(li.content)}</li>
              ) : (
                ''
              );
            })}
          </ul>
        ) : (
          ''
        )}
        <br />
        <br />
        {keyValidate('support_Faq3heading4') ? (
          <span className={styles.SupportSectionTitle}>
            {t('support_Faq3heading4')}
          </span>
        ) : (
          ''
        )}
        <br />
        <br />
        {keyValidate('support_Faq3heading5') ? (
          <span className={styles.SupportSectionTitle}>
            {t('support_Faq3heading5')}
          </span>
        ) : (
          ''
        )}
        <br />
        <br />
        {keyValidate('support_Faq3heading6') ? (
          <span className={styles.SupportSectionTitle}>
            {t('support_Faq3heading6')}
          </span>
        ) : (
          ''
        )}
        <br />
        <br />
        {keyValidate('support_Faq3heading6ol1') ? (
          <div className={styles.customLi}>
            <span>(1)</span>
            <span>
              {t('support_Faq3heading6ol1')}
              {keyValidate('support_Faq3heading6ol1link') ? (
                <a
                  href={t('support_Faq3heading6ol1link')}
                  className={styles.hreflink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('support_Faq3heading6ol1link')}
                </a>
              ) : (
                ''
              )}
            </span>
          </div>
        ) : (
          ''
        )}
        {keyValidate('support_Faq3heading6ol2') ? (
          <div className={styles.customLi}>
            <span>(2)</span>
            <span>{t('support_Faq3heading6ol2')}</span>
          </div>
        ) : (
          ''
        )}
      </div>
    </>
  );
}

const CustomSectionContent = (props) => {
  const {
    storeConfig: { language },
  } = useContext(StoreConfigContext);
  if (language === 'ja') {
    return <JapaneseStoreContent {...props} />;
  } else {
    return <DefaultStoreContent {...props} />;
  }
};

export default CustomSectionContent;
